import { computed } from 'vue';
import { rawDynamicImport } from '@app/helpers/memberships/section';
import { data } from '@app/memberships/state/store';

export default function(validate, form){

    const hasExistingContact = computed(
        () => data.membership_type.is_individual_membership.value
            ? data.member.has_individual_contact.value
            : data.member.has_organisation_contact.value
    )

    return {
        title     : 'Contact details',
        component : rawDynamicImport(() => import('@app/memberships/components/form/stages/contact_details/ContactDetails.vue')),
        isValid   : computed(
            () => hasExistingContact.value || validate({
                'contact.email'                       : ['required', 'email'],
                'contact.email_confirmation'          : ['required', 'email'],
                'contact.contact_number'              : ['required'],
                'contact.contact_number_confirmation' : ['required'],
                'contact.address_line_1'              : ['required'],
                'contact.postcode'                    : ['required'],
                'contact.city'                        : ['required'],
                'contact.county'                      : ['required'],
                'contact.country'                     : ['required'],
            })
        ),
        data: computed(
            () => ({
                contact: {
                    email                       : form.value.contact?.email,
                    email_confirmation          : form.value.contact?.email_confirmation,
                    contact_number              : form.value.contact?.contact_number,
                    contact_number_confirmation : form.value.contact?.contact_number_confirmation,
                    mobile_number               : form.value.contact?.mobile_number,
                    address_line_1              : form.value.contact?.address_line_1,
                    address_line_2              : form.value.contact?.address_line_2,
                    city                        : form.value.contact?.city,
                    postcode                    : form.value.contact?.postcode,
                    county                      : form.value.contact?.county,
                    country                     : form.value.contact?.country
                }
            })
        ),
        onReloadData : (progression) => {
            form.value.contact = progression.data.contact
        },
    }
}